export enum GrantSubmissionStatus {
  Accepted = 'Accepted',
  DataEntry = 'Data entry in progress',
  DataSubmitted = 'Data submitted',
  NotStarted = 'Not started',
  QualityCheck = 'Quality review in progress',
  ReadyForReview = 'Ready for OPA review',
  Returned = 'Return for remediation',
}
